<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Copyright" epub:type="copyright-page">
<p class="copyf" id="copyright"><span aria-label=" Page xi. " epub:type="pagebreak" id="page_xi" role="doc-pagebreak"><b>Copyright © 2021 by Jeremy Lent. All rights reserved.</b></span></p>
<p class="copy">Cover design by Diane McIntosh. Cover photo © iStock</p>
<p class="copy">Printed in Canada. First printing July 2021.</p>
<p class="copy">Published in the UK by Profile Books. Published under license in North America by New Society Publishers</p>
<p class="copy">This book is intended to be educational and informative. It is not intended to serve  as a guide. The author and publisher disclaim all responsibility for any liability, loss or risk that may be associated with the application of any of the contents of this book.</p>
<p class="copy">Inquiries regarding requests to reprint all or part of <i>The Web of Meaning</i> should be addressed to New Society Publishers at the address below. To order directly from the publishers, please call toll-free (North America) 1-800-567-6772,  or order online at <a href="http://www.newsociety.com" target="_blank">www.newsociety.com</a></p>
<p class="copy">Any other inquiries can be directed by mail to: New Society Publishers<br/>P.O. Box 189, Gabriola Island, BC V0R 1X0, Canada<br/>(250) 247-9737</p>
<p class="copy">L<span class="small">IBRARY AND</span> A<span class="small">RCHIVES</span> C<span class="small">ANADA</span> C<span class="small">ATALOGUING IN</span> P<span class="small">UBLICATION</span></p>
<p class="copy">Title: The web of meaning : integrating science and traditional wisdom to  find our place in the universe / Jeremy Lent.</p>
<p class="copy">Names: Lent, Jeremy, 1960- author.</p>
<p class="copy">Description: Includes bibliographical references and index.</p>
<p class="copy">Identifiers: Canadiana (print) 20210124776 | Canadiana (ebook) 20210125101<br/>| ISBN 9780865719545<br/>(hardcover) | ISBN 9781550927474 (PDF) | ISBN 9781771423434 (EPUB)<br/>Subjects: LCSH: Philosophical anthropology. | LCSH: Life. | LCSH: Meaning  <br/>(Philosophy) | LCSH:<br/>Ecologyb</p>
<figure><img alt="" src="images/f00xi-01.jpg"/></figure>
<p class="copy">New Society Publishers’ mission is to publish books that contribute in fundamental ways to building an ecologically sustainable and just society, and to do so with the least possible impact on the environment, in a manner that models this vision.</p>
<figure><img alt="" src="images/f00xi-02.jpg"/></figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0e2691b6